<template>
    <main id="games-wrapper">
        <div id="games-page">
            <breadcrumb
                :breadcrumb="[
                    { title: 'Community', url: '/', status: false },
                    { title: 'Games', url: '/games', status: true }
                ]"
            ></breadcrumb>
            <div class="container py-4">
                <div class="row justify-content-center">
                  <games :noCarousel="true"  />
                </div>
            </div>
        </div>
    </main>
</template>
<script>
import { isMobile } from "mobile-device-detect";
import Games from "../../widget/Games";
import BreadCrumb from "../../widget/BreadCrumb";

export default {
    components: {
        breadcrumb: BreadCrumb,
        games: Games
    },
    data() {
        return {
            mobile: false
        };
    },
    created() {
        this.mobile = isMobile;
    },
    methods: {}
};
</script>

<style scoped lang="scss">
#games-page{
    background: #000000;
}
</style>
